module.exports = __webpack_public_path__ + "img/unfold-icon-1.92d6a055.png";